var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61224 15.5091L0 20.7443H3.82507L4.50729 19.2775C6.65306 22.1516 10.035 24 13.8367 24C18.3557 24 22.2682 21.3883 24.2332 17.5662L26.2624 20.7861H30V7.40571H26.5773V14.6743L25.5219 13.0822C25.551 12.7245 25.5743 12.3667 25.5743 12.003C25.5743 9.63578 24.898 7.42957 23.7434 5.56919H30.0058V2.80845H21.3819C19.3411 1.0554 16.7114 0 13.8367 0C7.35277 0 2.09913 5.37242 2.09913 12.003C2.09913 13.2253 2.27988 14.4 2.61224 15.5091ZM4.50729 19.2775C3.67347 18.1565 3.02624 16.8865 2.61224 15.5091L6.65306 7.40571H10.3848L7.2828 13.5652H10.4315V16.8745H5.62099L4.50729 19.2775ZM15.5627 20.7443H12.1458V5.56919H7.96501L9.09038 2.80845H21.3878C22.309 3.59553 23.102 4.52571 23.7493 5.56919H15.5627V20.7443ZM24.2332 17.5662L21.5394 13.2969V20.7443H17.6735V7.40571H21.7668L25.5219 13.0822C25.3819 14.6922 24.9329 16.2067 24.2332 17.5662Z",
    fill: "#EF3B2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2332 17.5662L21.5394 13.2969V20.7444H17.6735V7.40574H21.7668L25.5219 13.0823C25.3819 14.6922 24.9329 16.2067 24.2332 17.5662ZM4.50729 19.2775C3.67347 18.1565 3.02624 16.8865 2.61224 15.5091L6.65306 7.40574H10.3848L7.2828 13.5652H10.4315V16.8746H5.62099L4.50729 19.2775ZM15.5627 20.7444H12.1458V5.56922H7.96501L9.09038 2.80847H21.3877C22.309 3.59555 23.102 4.52574 23.7493 5.56922H15.5627V20.7444Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b0803144a7790df860b395634f32b4a6.svg";
export { ForwardRef as ReactComponent };